export default "__VITE_ASSET__DyTgh95x__"